module.exports = __webpack_public_path__ + "img/picz_logo_blue_small.62624b87.svg";